import { useEffect } from "react";

// Configures native-only behaviour (status bar, splash, Android back button).
// Safe no-op on web: all Capacitor calls are dynamically imported and guarded.
export function useNativeSetup() {
  useEffect(() => {
    let cleanup = () => {};
    (async () => {
      try {
        const { Capacitor } = await import("@capacitor/core");
        if (!Capacitor?.isNativePlatform?.()) return;

        const { StatusBar, Style } = await import("@capacitor/status-bar");
        StatusBar.setStyle({ style: Style.Light }).catch(() => {});
        StatusBar.setBackgroundColor({ color: "#6b9df2" }).catch(() => {});

        const { SplashScreen } = await import("@capacitor/splash-screen");
        SplashScreen.hide().catch(() => {});

        const { App } = await import("@capacitor/app");
        const handle = await App.addListener("backButton", ({ canGoBack }) => {
          if (canGoBack) window.history.back();
          else App.exitApp();
        });
        cleanup = () => handle.remove();
      } catch {
        /* not running under Capacitor — ignore */
      }
    })();
    return () => cleanup();
  }, []);
}
